import React from 'react';
import { SectionContainer } from 'components/section';
import ActionContainer, { ActionContainerProps } from '../containers/actionContainer';
import RMTable, { TableProps } from 'components/customComponents/Controls/RMTable';
import TableSortInputFilter from 'components/customComponents/Controls/tableSortInputFilter';
import { IStyle } from 'Styles';

interface Props {
  headerTitle?: string;
  containerStyle?: React.CSSProperties;
  headerContainerStyle?: React.CSSProperties;
  actionContainerProps?: ActionContainerProps;
  tableProps?: TableProps;
  tableContainerStyle?: React.CSSProperties;
}

const handleTableFilter = (filterTitle: string) => (event: any) =>
  <TableSortInputFilter event={event} title={filterTitle} />;

const BaseGroup = (props: Props) => {
  const {
    tableContainerStyle,
    containerStyle,
    headerContainerStyle,
    actionContainerProps,
    tableProps,
    headerTitle = '',
  } = props;

  return (
    <SectionContainer
      containerStyle={containerStyle}
      leftHeaderComponent={
        headerTitle && <div style={styles.headerTitle}>{headerTitle}</div>
      }
      headingContainerStyle={{ ...styles.headerContainer, ...headerContainerStyle }}
      rightHeaderComponent={
        actionContainerProps && <ActionContainer {...actionContainerProps} />
      }
    >
      <div
        id="basegroup-table-container"
        className="user-setup-table"
        style={{ ...styles.tableContainer, ...tableContainerStyle }}
      >
        <RMTable {...tableProps} />
      </div>
    </SectionContainer>
  );
};

const styles: IStyle = {
  headerContainer: {
    paddingRight: '2%',
    paddingBottom: '0.5%',
    paddingTop: 0,
  },
  headerTitle: {
    fontWeight: 'bold',
  },
  tableContainer: {
    height: '85%',
  },
};

export { BaseGroup, handleTableFilter };
